import React from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Switch } from '@mui/material';

const propTypes = {
	name: PropTypes.string.isRequired,
	formik: PropTypes.object.isRequired,
	label: PropTypes.string,
	labelPlacement: PropTypes.string,
};

const defaultProps = {
	labelPlacement: 'end'
}

function FormikSwitch(props) {
	const { name, label, labelPlacement, formik, ...rest } = props;
	return (
		<FormControlLabel
			label={label}
			labelPlacement={labelPlacement}
			control={
				<Switch
					id={name}
					name={name}
					checked={formik.values[name]}
					onChange={formik.handleChange}
					{...rest}
				/>
			}
		/>
	);
}

FormikSwitch.propTypes = propTypes;
FormikSwitch.defaultProps = defaultProps;

export default FormikSwitch;
